<template>
  <div class="full" @click="openFSPicker">
    <div
      class="upload"
    >
      <v-icon large color="white">file_upload</v-icon>
      <span>{{ adminText('workflowsAll.upload_image_159031e', 'Upload Image') }}</span>
    </div>
    <hidden-file-input ref="file-input" max-file-size-mb="10" @file="processImage($event)" />
  </div>
</template>

<script>
import WorkflowDisplay from '@/admin-i18n/workflows-all-display'

import { resizeImage, fileToImage } from './../../utils'
import { getSignedURL, uploadImage } from './../../http'
import HiddenFileInput from './../shared/hidden-file-input'
import { getBuilderImageResizeOptions } from './../../builder-image-sizing'

const uuidv4 = require('uuid/v4')

export default {
  mixins: [WorkflowDisplay],
  components: {
    HiddenFileInput,
  },
  props: {
    url: String,
    eventId: String,
  },
  methods: {
    async uploadImage(file, path){
      const { upload: uploadURL, download: downloadURL } = await getSignedURL(path)
      await uploadImage(uploadURL, file)

      return downloadURL
    },
    async processImage(f) {
      const image = await fileToImage(f)
      const file = await resizeImage(image, {
        to: 'file',
        mime: f.type,
        ...getBuilderImageResizeOptions(),
      })
      const path = `${this.eventId}/builder/${uuidv4()}`
      const httpURL = await this.uploadImage(file, path)
      this.$emit('update:url', httpURL)
    },
  },
}
</script>

<style scoped>
.full {
  width: 100%;
  height: 100%;
}

.upload {
  width: 100%;
  height: 100%;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #979797;
  color: #FFF;
  text-transform: uppercase;
}
</style>
